/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceDeleteOrdersResponse model module.
 * @module model/ServiceDeleteOrdersResponse
 * @version version not set
 */
export class ServiceDeleteOrdersResponse {
  /**
   * Constructs a new <code>ServiceDeleteOrdersResponse</code>.
   * @alias module:model/ServiceDeleteOrdersResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceDeleteOrdersResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceDeleteOrdersResponse} obj Optional instance to populate.
   * @return {module:model/ServiceDeleteOrdersResponse} The populated <code>ServiceDeleteOrdersResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceDeleteOrdersResponse();
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbResponseState} state
 */
ServiceDeleteOrdersResponse.prototype.state = undefined;


